import { FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';
import { Link } from 'react-router-dom';

interface ModelInfoProps {
  name: string;
  fieldCount: number;
  requiredFields: number;

  packageUuid?: string;
  packageVersionUuid?: string;
  uuid?: string;
}
export const ModelInfo: FC<ModelInfoProps> = ({
  name,
  fieldCount,
  requiredFields,
  packageUuid,
  packageVersionUuid,
  uuid
}) => (
  <FlexLayout p="md" bg="lightGrey" borderRadius="small" flexDirection="column" css={{ minWidth: '200px' }}>
    <H4 fontWeight="semiBold" fontSize="lg">
      {name}
      {packageVersionUuid && uuid && packageUuid && (
        <Link to={`/packages/${packageUuid}/${packageVersionUuid}/structures/${uuid}`}>
          <Icon src="openInNew" color="secondary" stroke="transparent" />
        </Link>
      )}
    </H4>
    <H4 mt="md" color="secondary" fontWeight="bold">
      {fieldCount} FIELDS
    </H4>
    <H4 color="secondary">{requiredFields} Required</H4>
  </FlexLayout>
);
